/**
 * Panneau admin de la Bibliothèque d'exercices — wraps <ExerciseLibrary> avec
 * un `authFetch` qui utilise le cookie de session admin + CSRF sur les mutations.
 */
import { useMemo } from 'react';
import ExerciseLibrary from '../tracking/workouts/ExerciseLibrary';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminExerciseLibraryPanel = ({ csrfToken }) => {
  const authFetch = useMemo(() => (path, options = {}) => {
    const method = (options.method || 'GET').toUpperCase();
    const isMutation = method !== 'GET' && method !== 'HEAD';
    return fetch(`${BACKEND_URL}${path}`, {
      ...options,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(isMutation && csrfToken ? { 'X-CSRF-Token': csrfToken } : {}),
        ...(options.headers || {}),
      },
    });
  }, [csrfToken]);

  return (
    <div className="bg-zinc-900 border border-white/10 rounded-2xl p-4 mb-5" data-testid="admin-library-panel">
      <ExerciseLibrary authFetch={authFetch} en={false} isAdmin={true} />
    </div>
  );
};

export default AdminExerciseLibraryPanel;
